import Modal from "../General/Modal"
import Image from "next/image"
import { useDispatch } from "react-redux"

function EnquiryResponseSuccess({ show, onClose }: any) {
    const dispatch = useDispatch();

    return (
        <Modal show={show} styles='w-[80%] lg:w-1/4' transition="animateup">
            <div className="content pt-4 pb-10 px-3">
                <div className="flex justify-end">
                    <svg onClick={onClose} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 cursor-pointer">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>

                <div className="flex justify-center items-center">
                    <img
                        src={'/Layout/EnquirySuccess.png'}
                        width={200}
                        height={200}
                        alt='Success'
                        className="pt-3 pb-6"
                    />
                </div>

                <div className="content text-center px-10">
                    <p className="pt-2 text-theme-black font-light">
                        <span className="text-theme-orange font-semibold">Thank you </span>
                        You have submitted your response successfully! 🎉
                    </p>
                </div>
            </div>
        </Modal>
    )
}

export default EnquiryResponseSuccess